import { BaseNodeTreeStrategy } from "./BaseNodeTreeStrategy";

export class DefaultNodeTreeStrategy extends BaseNodeTreeStrategy {
    createNodeTree(context) {
        const nodeTree = super.createNodeTree(context);
        this.addPathToNodeTree(nodeTree, ['id']);
        return nodeTree;
    }
}
